

import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        let metaValue = [];
        try {
            if (this.diplomaInfo?.attributes?.meta != null &&
                this.diplomaInfo?.attributes?.meta != undefined &&
                Array.isArray(JSON.parse(this.diplomaInfo?.attributes?.meta.replace('\n', '')))) { metaValue = JSON.parse(this.diplomaInfo?.attributes?.meta.replace('\n', '')); }
        } catch (e) {
        }

        return {
            title: `${this.diplomaInfo?.attributes?.metaTitle}`,
            meta: metaValue
        };
    },

    data() {

        const isOpen = false
        const dublon = false

        let tabVisibility = {
            objectif: true,
            cours: false,
            programmes: false,
            admission: false,
            enseignants: false,
            etudes: false
        };

        let registerForm = {
            session: '',
            inscription: '',
            civilite: '',
            prenom: '',
            nom: '',
            telephone: '',
            email: '',
            dateOfBirth: '',
            codePostal: '',
            ville: '',
            mobilite: '',
            bacSerie: '',
            bac: '',
            diplomeDeNiveauBac2: '',
            diplomeDeNiveauBac3: '',
            resumeProjet: '',
            planRegion: '',
            entreprise: '',
            consent: '',
            cv: null
        };

        let listCities = [];


        return {
            tabVisibility,
            showSubscribe: false,
            registerForm,
            listCities,
            departementExplantionNeeded: false,
            formSent: false,
            sending: false,
            isOpen,
            dublon,
        }
    },

    setup() {
        return { v$: useVuelidate() }
    },
    validations() {

        let register = {
            registerForm: {
                session: { required },
                inscription: { required },
                civilite: { required },
                prenom: { required },
                nom: { required },
                email: { required, email },
                telephone: { required, mustBePhoneNumber },
                dateOfBirth: { required },
                codePostal: { required },
                ville: { required },
                bacSerie: { required },
                bac: { required },
                mobilite: { required },
                consent: { required },
            }

        }

        if (this.diplomaInfo?.attributes?.prerequisNiveau === 'BAC') {
            register.registerForm.bacSerie = { required };
            register.registerForm.bac = { required };
        } else {
            register.registerForm.bacSerie = {};
            register.registerForm.bac = {};
        }

        if (this.registerForm?.inscription == 'enAlternance') {
            register.registerForm.entreprise = { required };
        } else {
            register.registerForm.entreprise = {};
        }


        return register
    },

    mounted() {

        if (process.browser) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('inView');
                    }
                });
            }, {
                threshold: 0
            });

            [...document.querySelectorAll('.animatableDiploma')].map(animatableDiploma => {
                observer.observe(animatableDiploma);
            })

        }

        const options = {
            root: null, // Use the viewport as the root
            rootMargin: '-50% 0 0 0', // Set the rootMargin, you can use any valid CSS margin value
        };
        if (process.browser) {
            const observer = new IntersectionObserver((entries, options) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('inView');
                    }
                });
            }, {
                threshold: 0.3
            });

            [...document.querySelectorAll('.animationBotomToTopDiploma')].map(animationBotomToTopDiploma => {
                observer.observe(animationBotomToTopDiploma);

            })

        }

        const firstSession = this.diplomaInfo?.attributes?.sessions?.data.sort((a, b) => {
            return new Date(a.attributes.dateDebut) - new Date(b.attributes.dateDebut);
        })[0].attributes.idSessionCRM;

        if (this.diplomaInfo?.attributes?.sessions?.data?.length > 0) {
            this.registerForm.session = firstSession;
        }
        if (this.diplomaInfo?.attributes?.typeDiplomeAlternance) {
            this.registerForm.inscription = 'enAlternance';
        } else {
            this.registerForm.inscription = 'enFormation';
        }


    },

    methods: {
        checkRegisterForm() {
        },
        closeSubscription(event) {
            this.showSubscribe = !this.showSubscribe;
        },
        changeTab(wantedTab) {
            Object.keys(this.tabVisibility).forEach(v => {
                if (v == wantedTab) this.tabVisibility[v] = true
                else this.tabVisibility[v] = false
            });

            let element = this.$refs['tabContainer'];
            let top = element.offsetTop;
            if (window.scrollY > top) {
                window.scrollTo(0, top);
            }
        },
        scrollToElement() {
            const element = document.getElementById("postule");
            element.scrollIntoView({ behavior: 'smooth' });
        },
        chooseFiles() {
            document.getElementById("fileUpload").click()
        },
        giveMonth(date) {
            let splitedDate = date.split('-');
            let newDate = new Date(splitedDate[0], splitedDate[1] - 1, splitedDate[2]);
            return newDate.toLocaleString('default', { month: 'long' });
        },
        clickSeries() {
            this.displayedBacs = this.bacs.filter(bac => bac.serieSimple === this.registerForm.bacSerie)
        },
        previewFiles(event) {
            this.registerForm.cv = event.target.files[0];
        },
        resetInput() {
            this.registerForm.cv = null;
        },
        async changeEvent() {
            let listCities = await this.$http.$get(`${process.env.apiCrmServer}villes.php?code_postal=${this.registerForm.codePostal}`);
            this.listCities = listCities.data;
            if (this.registerForm.codePostal.length > 4 && this.registerForm.codePostal.substring(0, 2) != '34' && this.registerForm.codePostal.substring(0, 2) != '30') {
                this.departementExplantionNeeded = true
            } else {
                this.departementExplantionNeeded = false
            }
        },
        async sendStudent() {
            try {
                if (await this.v$.$validate()) {
                    this.sending = true;

                    this.registerForm.diplome = this.diplomaInfo?.attributes.idDiplomeCRM;
                    this.registerForm.campus = this.instance?.attributes.idCampusCRM;

                    // send url, diplomq ID and prefix of campus
                    this.registerForm.url = window.location.host + "" + this.$nuxt.$route.path;
                    this.registerForm.campusDiplomaId = this.diplomaInfo.id;
                    this.registerForm.diplomaAcronyme = this.diplomaInfo.attributes?.acronyme;
                    this.registerForm.campusPrefix = this.instance.attributes.prefix;
                    this.registerForm.campusName = this.instance.attributes.name;
                    this.registerForm.niveauDiplome = this.diplomaInfo?.attributes?.niveauDiplome?.data?.attributes?.description;
                    this.registerForm.utm = JSON.stringify(this.$store.state.utm);

                    let formData = new FormData();
                    formData.append('cv', this.registerForm.cv);
                    this.registerForm.cv = this.registerForm.cv?.name
                    formData.append('data', JSON.stringify(this.registerForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}candidature_form_offre_emploi.php?`, formData);

                    if (result == "success") {
                        this.formSent = true;
                    } else if (result.code == 'alreadyExist') {
                        // display popup
                        this.sending = false;
                        this.dublon = true;
                        this.isOpen = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }
                }
            } catch (error) {
                this.isOpen = true
                this.sending = false;
            }
        },
    },


    async asyncData({ params, $http, store, redirect }) {
        let instance = store.state.instance;

        let detailInfo = store.state.detailInfo;

        if (!instance) {
            let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
            instances = instances.data;

            instance = instances.filter((instance) => {
                return instance?.attributes.subFolderName == params.campusHP
            })[0];
        }

        if (!instance) {
            // redirect to lost page
            redirect('/404-error/')
        }


        let campusInfo = store.state.campusInfo;
        // let campusInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-home-page?populate=
        // banniere,banniereLogo,plusCampusLogo,avantageCampusLogo1,avantageCampusLogo2,avantageCampusLogo3,
        // detailCampusImage,tousNosCentresImage`);
        // campusInfo = campusInfo.data;

        // TO DO: add id of the diploma setimg filter on the store diploma to get the diploma
        // let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-diplomas?populate=banniere,iconeControleDiplome,niveauDiplome,sessions`);
        // campusDiplomas = campusDiplomas.data;
        // const diplomaInfo = campusDiplomas.filter((diploma) => {
        //     return diploma?.attributes.nomEnteteDiplome == params.diploma.replace('-', ' ')
        // })[0];

        let diplomaInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-diplomas?filters[nomEnteteDiplome][$eq]=${params.diploma.replace('-', ' ')}&populate=banniere,iconeControleDiplome,niveauDiplome,sessions`);
        diplomaInfo = diplomaInfo.data[0];
        if (!diplomaInfo) {
            // redirect to lost page
            redirect('/404-error/')
        }

        let campusDiplomas = JSON.parse(JSON.stringify(store.state.campusDiplomas));

        let collone1Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_1';
        })
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone2Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_2';
        })
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone3Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_3';
        })
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })

        let typeFormation = '';
        if (diplomaInfo?.attributes?.typeDiplomeAlternance) {
            typeFormation = typeFormation + 'en alternance'
        }
        if (diplomaInfo?.attributes?.typeDiplomeContinue) {
            if (typeFormation.length > 0) {
                typeFormation = typeFormation + ' ou' + ' '
            }
            typeFormation = typeFormation + 'en formation continue'
        }
        if (diplomaInfo?.attributes?.typeDiplomeInitial) {
            if (typeFormation.length > 0) {
                typeFormation = typeFormation + ' ou' + ' '
            }
            typeFormation = typeFormation + 'en initial scolaire'
        }

        if (typeFormation.length > 0) {
            diplomaInfo.attributes.typeFormation = typeFormation.charAt(0).toUpperCase() + typeFormation.slice(1);
        }



        let iconeControleDiplomeUrl = process.env.strapiBaseUri + diplomaInfo?.attributes.iconeControleDiplome?.data?.attributes?.url;
        let banniereUrl = process.env.strapiBaseUri + diplomaInfo?.attributes.banniere?.data?.attributes?.url;
        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo?.attributes.banniereLogo?.data?.attributes?.url;


        let avantageCampusLogo1Url = process.env.strapiBaseUri + campusInfo?.attributes.avantageCampusLogo1?.data?.attributes?.url;
        let avantageCampusLogo2Url = process.env.strapiBaseUri + campusInfo?.attributes.avantageCampusLogo2?.data?.attributes?.url;
        let avantageCampusLogo3Url = process.env.strapiBaseUri + campusInfo?.attributes.avantageCampusLogo3?.data?.attributes?.url;
        let detailCampusImageUrl = process.env.strapiBaseUri + campusInfo?.attributes.detailCampusImage?.data?.attributes?.url;
        let tousNosCentresImageUrl = process.env.strapiBaseUri + campusInfo?.attributes.tousNosCentresImage?.data?.attributes?.url;

        const tabHTML = {
            objectif: diplomaInfo.attributes.enBref,
            cours: diplomaInfo.attributes.programme,
            programmes: diplomaInfo.attributes.modalitesDEtude,
            admission: diplomaInfo.attributes.modalitesDAmission,
            enseignants: diplomaInfo.attributes.enseignantsFormateurs,
            etudes: diplomaInfo.attributes.poursuiteEtude
        }

        let bacSeries = await $http.$get(`${process.env.apiCrmServer}bac.php?query=series`);
        bacSeries = bacSeries.filter(bacSerie => bacSerie.serie);
        let bacs = await $http.$get(`${process.env.apiCrmServer}bac.php?query=bacs`);
        let displayedBacs = bacs;
        let yourDate = new Date();
        yourDate = yourDate.toISOString().split('T')[0];
        let jposInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-jpos?filters[dateJPO][$gte]=${yourDate}&filters[dateDebutAff][$lte]=${yourDate}`);
        jposInfo = jposInfo.data;

        return {
            instance, campusInfo, diplomaInfo, detailInfo, iconeControleDiplomeUrl, banniereUrl,
            banniereLogoUrl, avantageCampusLogo1Url, avantageCampusLogo2Url,
            avantageCampusLogo3Url, tabHTML, collone1Diplomas, collone2Diplomas,
            collone3Diplomas, jposInfo, bacSeries, bacs, displayedBacs, detailCampusImageUrl, tousNosCentresImageUrl
        }
    },

}
